module.exports = __webpack_public_path__ + "static/img/aigc.ae65a39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CCT001/aigc.png
// module id = M2KT
// module chunks = 1